"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldTtsForGrowthSuitePromoSelector = exports.isCovidGrowthSuitePromoEligibleSelector = exports.shouldShowCovidRemoteSalesToolsPromo = void 0;

var _PublicFeatureFlagSelectors = require("pricing-pages-unified-ui/selectors/PublicFeatureFlagSelectors");

var _PublicFeatureFlags = require("pricing-pages-unified-ui/constants/PublicFeatureFlags");

var _GatingSelectors = require("pricing-pages-unified-ui/selectors/GatingSelectors");

var _GateKeys = require("self-service-api/constants/GateKeys");

var _PromotionSelectors = require("./PromotionSelectors");

var shouldShowCovidRemoteSalesToolsPromo = function shouldShowCovidRemoteSalesToolsPromo(state) {
  var isPublicFlagTrue = (0, _PublicFeatureFlagSelectors.publicFeatureFlagSelector)(state, _PublicFeatureFlags.CBX_COVIDRESPONSE_REMOTE_SALES_TOOLS);
  var isInAppUngated = (0, _GatingSelectors.isUngatedSelector)(state, _GateKeys.COVID_REMOTE_SALES_TOOLS);
  return isPublicFlagTrue || isInAppUngated;
};

exports.shouldShowCovidRemoteSalesToolsPromo = shouldShowCovidRemoteSalesToolsPromo;

var isCovidGrowthSuitePromoEligibleSelector = function isCovidGrowthSuitePromoEligibleSelector(state) {
  var isPublicFlagTrue = (0, _PublicFeatureFlagSelectors.publicFeatureFlagSelector)(state, _PublicFeatureFlags.CBX_COVIDRESPONSE_GROWTH_SUITE_DISCOUNT);
  var isInAppUngated = (0, _GatingSelectors.isUngatedSelector)(state, 'COVIDResponse:GrowthSuiteDiscount'); // Exclude HSFS seed users bc they have a better discount than covid promotion

  if ((0, _PromotionSelectors.isHsfsSeedEligibleSelector)(state)) {
    return false;
  }

  return isPublicFlagTrue || isInAppUngated;
};

exports.isCovidGrowthSuitePromoEligibleSelector = isCovidGrowthSuitePromoEligibleSelector;

var shouldTtsForGrowthSuitePromoSelector = function shouldTtsForGrowthSuitePromoSelector(_ref) {
  var covidSuitePromoCheckoutEligibility = _ref.covidSuitePromoCheckoutEligibility;
  return !covidSuitePromoCheckoutEligibility;
};

exports.shouldTtsForGrowthSuitePromoSelector = shouldTtsForGrowthSuitePromoSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/CovidSelectors.js
// module id = 86
// module chunks = 5 6